import JobListStyle2Container from "../../../components/job/other/JobListStyle2";

const JobListStyle2 = () => {
  return <JobListStyle2Container />;
};

export default JobListStyle2;
